export default __webpack_public_path__ + "static/media/icon-cloud-server.edba8d68.svg";